import { render, staticRenderFns } from "./switcherNotLiveAdUnitIcon.vue?vue&type=template&id=58796e60&"
import script from "./switcherNotLiveAdUnitIcon.vue?vue&type=script&lang=js&"
export * from "./switcherNotLiveAdUnitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports